import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import AnnualAccountCommentFormContainer from "./commentFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useAnnualAccountCommentDialog(onCommentSuccess?: (value?: any) => void) {
  const getCommentDialog = (id: number): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Comment),
      titleIcon: IconDefinitionConstants.WCommentDots,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Send),
          successMessage: TranslationKeys.AnnualAccount.AnnualReportCommentSuccessMessage,
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      children: <AnnualAccountCommentFormContainer id={id} />,
      maxWidth: "sm",
      onSubmit: onCommentSuccess,
    };
  };

  return getCommentDialog;
}

export default useAnnualAccountCommentDialog;
